import { useSelector, useDispatch } from 'react-redux';

export const useAppSelector = useSelector;
export const useAppDispatch = useDispatch;

// Selectores para autenticación de usuarios
export const useAuthState = () => useAppSelector(state => state.auth);
export const useConfigState = () => useAppSelector(state => state.config);

// Selectores para autenticación de administradores
export const useAdminAuthState = () => useAppSelector(state => state.adminAuth);

// Selectores específicos para administradores
export const useAdminAuth = () => {
  const adminAuth = useAppSelector(state => state.adminAuth);
  return {
    isAuthenticated: adminAuth.isAuthenticated,
    adminData: adminAuth.adminData,
    token: adminAuth.token,
    loading: adminAuth.loading,
    error: adminAuth.error,
    isInitialized: adminAuth.isInitialized,
  };
};

// Selector para verificar si el usuario está autenticado como administrador
export const useIsAdminAuthenticated = () => useAppSelector(state => state.adminAuth.isAuthenticated);

// Selector para obtener datos del administrador
export const useAdminData = () => useAppSelector(state => state.adminAuth.adminData); 